/* eslint ember/no-classic-classes:"off" */
import RESTAdapter from '@ember-data/adapter/rest';
export default RESTAdapter.extend({
  init(...args) {
    this._super(...args);
    this.useFetch = false;
  },
  namespace: '/api/v2/multiunit/subunits',
  allUnitSuffix: '?all_merchant_units=true',
  shouldBackgroundReloadRecord: () => false,
  shouldBackgroundReloadAll: () => false,
  pathForType() {
    return 'subunits';
  },
  urlForFindRecord(id) {
    return `${this.namespace}/${id}`;
  },
  urlForFindAll() {
    return `${this.namespace}${this.allUnitSuffix}`;
  }
});